import { Typography } from '@breetometer/components';
import { capitalizeFirstLetter } from 'BreetHelpers';
import type { RefObject } from 'react';

import type { IDropDown } from '../../Dropdown.helpers';
import { DefaultDropDownControl } from '../controls/Default';
import { DefaultInputValue } from '../input-value/Default';
import { DefaultDropdownItems } from '../items/Default';
import { DropdownWrapper } from '../Wrapper';

const DefaultDropDown = ({
	handleItemSelect,
	selectedItem,
	items,
	iconAs,
	hideValue,
	placeholder,
	label,
	id,
	children,
	errorMessage,
	hideSearch,
	CustomItemOption,
	CustomItemSelectedProps,
}: IDropDown) => (
	<div
		className='dropdown'
		data-testid='dropdown'
	>
		<DropdownWrapper>
			{(dropDownArgs) => {
				const { buttonRef, handleVisibility, visible, dropdownRef, controlRef, dropdownStyles } = dropDownArgs;

				return (
					<div className='dropdowninput bg-primary-500'>
						<div
							className='dropdown_content'
							ref={controlRef as RefObject<HTMLDivElement>}
						>
							<DefaultDropDownControl
								selectedItem={selectedItem}
								buttonRef={buttonRef}
								handleVisibility={handleVisibility}
								visible={visible}
								iconAs={iconAs}
								CustomItemSelectedProps={CustomItemSelectedProps}
								isLabel={!!label}
							/>

							{!!label && (
								<label
									className='bt_label'
									htmlFor={id}
								>
									{label}
								</label>
							)}

							{children}

							{visible && (
								<DefaultDropdownItems
									handleItemSelect={handleItemSelect}
									dropDownRef={dropdownRef}
									hideSearch={hideSearch}
									inputValue={
										<DefaultInputValue
											icon={selectedItem?.icon as string}
											iconAs={iconAs}
											value={selectedItem?.value}
										/>
									}
									items={items}
									iconAs={iconAs}
									hideValue={hideValue}
									placeholder={placeholder}
									dropdownStyles={dropdownStyles}
									handleVisibility={handleVisibility}
									CustomItemOption={CustomItemOption}
								/>
							)}
						</div>
					</div>
				);
			}}
		</DropdownWrapper>
		{!!errorMessage && (
			<Typography
				as='p'
				className='dropdown_errormessage'
			>
				{capitalizeFirstLetter(errorMessage)}
			</Typography>
		)}
	</div>
);

export default DefaultDropDown;
